import { operatorApiFetch } from './apiService';

export const shippingAccountService = {
  fetchList: async (params = {}) => {
    try {
      const queryString = new URLSearchParams(params).toString();
      const url = queryString ? `shipping_accounts?${queryString}` : 'shipping_accounts';
      const response = await operatorApiFetch(url);
      if (!response.ok) throw new Error('Failed to fetch shipping accounts');
      const data = await response.json();
      return { success: true, data: data.data };
    } catch (error) {
      console.error(error);
      return { success: false, error: error.message };
    }
  },

  getRecords: async (params) => {
    const response = await operatorApiFetch('shipping_accounts/get_records', { method: 'POST', body: JSON.stringify(params) });
    return response.json();
  },
  getIds: async (params) => {
    const response = await operatorApiFetch('shipping_accounts/get_ids', { method: 'POST', body: JSON.stringify(params) });
    return response.json();
  },

  get: async (id) => {
    const response = await operatorApiFetch(`shipping_accounts/${id}`);
    return response.json();
  },

  create: async (data) => {
    const response = await operatorApiFetch('shipping_accounts', {
      method: 'POST',
      body: JSON.stringify({ shipping_account: data })
    });
    return response.json();
  },

  update: async (id, data) => {
    const response = await operatorApiFetch(`shipping_accounts/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ shipping_account: data })
    });
    return response.json();
  },

  delete: async (id) => {
    const response = await operatorApiFetch(`shipping_accounts/${id}`, {
      method: 'DELETE'
    });
    return response.json();
  },

  disable: async (id) => {
    const response = await operatorApiFetch(`shipping_accounts/${id}/disable`, {
      method: 'PATCH'
    });
    return response.json();
  }
};
